import Archive from '@mui/icons-material/Archive';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ArchiveIcon(props: FixMe) {
  return <Archive {...props} />;
}

export default ArchiveIcon;
